export default {

  namespaced: true,

  state: () => ({

    resume: {
      openingBalance: {},
      sumByBillReceived: {},
      sumByCustomTransaction: {},
      sumByPaymentMethod: [],
      sumByPaymentMethodIsOut: [],
      transfers: {},
      transfersIsOut: {},
      orderTotal: {},
      totalCashOrders: {},
    }


  }),

  mutations: {

    setResume(state, data) {
      state.resume.openingBalance = data.openingBalance
      state.resume.sumByBillReceived = data.sumByBillReceived
      state.resume.sumByCustomTransaction = data.sumByCustomTransaction
      state.resume.sumByPaymentMethod = data.sumByPaymentMethod
      state.resume.sumByPaymentMethodIsOut = data.sumByPaymentMethodIsOut
      state.resume.transfers = data.transfers
      state.resume.transfersIsOut = data.transfersIsOut
      state.resume.orderTotal = data.orderTotal
      state.resume.billReceivedTotal = data.billReceivedTotal
      state.resume.totalCashOrders = data.totalCashOrders
    }

  },

  actions: {

    async getResume({ dispatch, commit }, params) {

      await axios.get("/erp/account/resume", params)
        .then(response => {

          commit("setResume", response.data);

        }).catch(error => {

          commit("userHasLoadedWithError", { error: error }, { root: true });

        })

    }

  }
}
